export const normalizeNumberInput = (value) => {
  if (value == null) return "";

  // 全角→半角（数字）
  const fullWidthNumberMap = {
    "０": "0",
    "１": "1",
    "２": "2",
    "３": "3",
    "４": "4",
    "５": "5",
    "６": "6",
    "７": "7",
    "８": "8",
    "９": "9",
  };
  const halfWidthString = String(value).replace(
    /[０-９]/g,
    (character) => fullWidthNumberMap[character],
  );

  // カンマ（全角/半角）と空白を除去し、数字とドット以外を削る
  let result = halfWidthString
    .replace(/[,\uFF0C]/g, "")
    .replace(/\s/g, "")
    .replace(/[^\d.]/g, "");
  // ドットが含まれる場合は、最初のドットより前（整数部分）のみを残す
  const dotIndex = result.indexOf(".");
  if (dotIndex !== -1) {
    result = result.slice(0, dotIndex);
  }

  return result;
};